import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return <footer className="site-footer container">
    <div><Link className="footer-brand" to="/">WB Tech Ventures</Link><p>Thoughtful products. Built and operated with care.</p></div>
    <nav aria-label="Footer navigation"><Link to="/projects">Projects</Link><Link to="/about">About</Link><Link to="/contact">Contact</Link><a href="/sitemap.xml">Sitemap</a></nav>
    <div className="footer-bottom"><span>© {new Date().getFullYear()} WB Tech Ventures LLC</span><a href="https://www.linkedin.com/in/wiehan-boshoff-b31649110">Connect with Wiehan <span aria-hidden="true">↗</span></a></div>
  </footer>;
}
